import layeredSoilAttribute from './layeredSoilAttribute';

const bulkDensity = (allLayers: boolean) =>
  layeredSoilAttribute({
    allLayers,
    key: 'Bulk Density, 1/3 Bar',
    ratingCol: {
      displayString: 'Bulk density (g/cm³)',
      accessor: 'mapUnitRatingString',
    },
    ruleId: '65',
    units: 'g/cm³',
  });

export const BULK_DENSITY_ALL_LAYERS = bulkDensity(true);
export const BULK_DENSITY_SURFACE_LAYER = bulkDensity(false);
